module.exports = __webpack_public_path__ + "static/img/et_06.1b609e0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/et/et_06.jpg
// module id = oP73
// module chunks = 1